import { render, staticRenderFns } from "./ModalPopup.vue?vue&type=template&id=2dc52ac6&"
import script from "./ModalPopup.vue?vue&type=script&lang=js&"
export * from "./ModalPopup.vue?vue&type=script&lang=js&"
import style0 from "./ModalPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports